export default __webpack_public_path__ + "static/media/banner4.0a014ea0.png";